import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getClient } from '../../services/chainClient';

const updateBalance = createAsyncThunk('wallet/updateBalance', async () => {
  const bitcoin = getClient();
  const addresses = (await bitcoin.client.getMethod('getUsedAddresses')()).map(
    (addr) => addr.address
  );

  const balance = await bitcoin.client.chain.getBalance(addresses);

  const staticPubkeyAddress = await bitcoin.getMethod('getAddresses')(
    0,
    2,
    false
  );

  const staticPubkeyPair = await bitcoin.getMethod('keyPair')(
    staticPubkeyAddress[1].derivationPath
  );

  console.log(
    'Your static public key:',
    staticPubkeyPair.publicKey.toString('hex')
  );

  return balance.toNumber();
});

const walletSlice = createSlice({
  name: 'wallet',
  initialState: {
    mnemonic: '',
    balance: 0,
    balanceUpdated: false,
    clientInitalized: false,
  },
  reducers: {
    setMnemonic(state, action: PayloadAction<string>) {
      const mnemonic = action.payload;
      state.mnemonic = mnemonic;
    },
    setClientInitialized(state, action: PayloadAction<boolean>) {
      console.log(state);
      state.clientInitalized = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateBalance.fulfilled, (state, action) => {
        state.balance = action.payload;
        state.balanceUpdated = true;
      })
      .addCase(updateBalance.rejected, (state, action) => {
        console.log(action);
      });
  },
});

export const { setMnemonic, setClientInitialized } = walletSlice.actions;
export { updateBalance };
export default walletSlice.reducer;
